<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3906 3C15.1748 3 15 3.19941 15 3.44531V21.5547C15 21.8007 15.1748 22 15.3906 22H19.6094C19.8251 22 20 21.8007 20 21.5547V3.44531C20 3.19941 19.8251 3 19.6094 3H15.3906Z"
      :fill="`url(#${componentId}paint0_linear_23_30)`"
    />
    <path
      d="M4.39061 3C4.17491 3 4 3.19932 4 3.44531V21.5547C4 21.8006 4.17491 22 4.39061 22H8.60939C8.82516 22 9 21.8006 9 21.5547V3.44531C9 3.19932 8.82516 3 8.60939 3H4.39061Z"
      :fill="`url(#${componentId}paint1_linear_23_30)`"
    />
    <defs>
      <linearGradient
        :id="`${componentId}paint0_linear_23_30`"
        x1="-5.49327"
        y1="18.0763"
        x2="16.431"
        y2="33.0803"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.51" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}paint1_linear_23_30`"
        x1="-6.49421"
        y1="18.0764"
        x2="15.4301"
        y2="33.0805"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#F87900" />
        <stop offset="0.51" stop-color="#FE4F45" />
        <stop offset="1" stop-color="#E419BA" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
